import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login/Login'
import Cabinet from '@/views/cabinet/Cabinet'
import CabinetDetail from '@/views/cabinet/CabinetDetail'
import Nofind from '@/views/noFind/404'
import Layout from '@/views/layout/Layout'
import User from '@/views/user/User'
import App from '@/views/app/App'
import Version from '@/views/version/Version'
import IndexVue from '@/views/index/IndexVue'
import Other from '@/views/other/Other'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/login',
      name: '登录',
      component: Login
    },
    {
      path: '/',
      name: '首页',
      component: Layout,
      redirect: '/cabinets',
      children: [
        { path: '/index', name: '', component: IndexVue },
        { path: '/cabinets', name: '机柜管理', component: Cabinet },
        { path: '/cabinetDetail', name: '机柜详情', component: CabinetDetail },
        { path: '/users', name: '用户管理', component: User, },
        { path: '/apps', name: 'app管理', component: App },
        { path: '/versions', name: '版本管理', component: Version },
        { path: '/other', name: '其他管理', component: Other },
      ]
    },
    {
      path: '*',
      component: Nofind
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js